export const SHOW_EXTERNAL_LINK = 'show_external_link'
export const SHOW_PLAY_HISTORY = 'show_play_history'
export const SHOW_DREAM_PURCHASES = 'show_dream_purchases'
export const SHOW_BUTTONS_MODAL_HOW_TO_PLAY = 'show_buttons_modal_how_to_play'
export const SHOW_ANALYZE_PERFORMANCE = 'show_analyze_performance'
export const REQUIRE_LOGIN_FOR_ANALYZE_PERFORMANCE = 'require_login_for_analyze_performance'
export const UNLOCK_LOTTERY_RESULTS = 'unlock_lottery_results'
export const SHOW_SCAN_TICKET = 'show_scan_ticket'
export const SHOW_TAB_SCAN_TICKET_ALWAYS = 'show_tab_scan_ticket_always'
export const ENABLE_ANALYZE_PERFORMANCE_HISTORY = 'enable_analyze_performance_history'
export const ENABLE_PRIZE_BREAKDOWN_HISTORY = 'enable_prize_breakdown_history'
